export default __webpack_public_path__ + "media/zurb/img/home/indiana-university-online-38e4d881c183c23d33259f178f83bd18.png";